import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { TOOLBAR_SELECT_WINDOW } from '@src/framework/editor/src/img/pageIndex';
import i18n from '@i18next/i18n';

export const config =   {
    id: ActionType.SELECT_WINDOW,
    icon: TOOLBAR_SELECT_WINDOW,
    content: i18n.t('全部图层'),
    tipPlacement: 'right',
};

export const SELECT_WINDOW_CONFIG = config;

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        hasArrow: true,
        text: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];
